import { Schema } from 'rsuite'
import { normalizePhoneNumber } from '@@partner:helpers/util'

const { StringType, NumberType, DateType } = Schema.Types

export const AssemblerFormValidationModel = Schema.Model({
  firstName: StringType().isRequired('Поле обязательно для заполнения!'),
  lastName: StringType().isRequired('Поле обязательно для заполнения!'),
  // status: NumberType().isRequired(),
  phone: StringType()
    .isRequired('Поле обязательно для заполнения')
    .addRule((value: string) => {
      const normalized = normalizePhoneNumber(value)
      return normalized.length === 11
    }, 'Некорректно заполнен номер телефона!')
})
